// extracted by mini-css-extract-plugin
export default {"enemy-container":"enemy_enemy-container__FD-LV","enemy":"enemy_enemy__YMuVt","special-tag":"enemy_special-tag__RH6JW"};